<template>
  <div class="home">
    <section role="banner">
      <b-container fluid class="px-0">
        <div class="banner">
          <b-jumbotron
            fluid
            class="d-flex flex-column justify-content-center mb-0"
          >
            <h1 class="w-50">
              Affordable digital solutions for <span>small</span> and
              <span>medium enterprises.</span>
            </h1>
            <b-button href="#" variant="primary">Learn more</b-button>
            <b-button href="#" variant="outline-primary" class="ml-3">Contact us</b-button>
          </b-jumbotron>
        </div>
      </b-container>
    </section>

    <section>
      <div class="ribbon w-100 text-center">
        <b-container class="py-5 mb-3 mb-md-5">
          <b-row>
            <b-col class="mb-5 mb-md-0 d-flex flex-column justify-content-center align-items-center">
              <b-img src="@/assets/skyteam-logo.png" width="225" />
            </b-col>
            <b-col class="mb-5 mb-md-0 d-flex flex-column justify-content-center align-items-center">
              <b-img src="@/assets/ryanair-logo.svg" width="200"/>
            </b-col>
            <b-col class="d-flex flex-column justify-content-center align-items-center">
              <b-img src="@/assets/netwatch-logo.png" width="170"/>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </section>

    <section>
      <b-container class="py-5 mb-5">
        <b-row>
          <b-col
            md="6"
          >
            <b-img
                src="@/assets/charts-isometric.png"
                alt="Google Analytics Logo"
                width="400"
                fluid
                center
            ></b-img>
          </b-col>
          <b-col
            md="5"
            class="d-flex flex-column justify-content-center offset-md-0 text-center text-md-left"
          >
            <div class="block">
                <h6>About us</h6>
                <h2>Reach new audiences the smart and easy way</h2>
                <p>
                  Sed ut perspiciatis unde omnis iste natus error sit voluptatem
                  accusantium doloremque laudantium, totam rem aperiam, eaque
                  ipsa quae ab illo inventore veritatis et quasi architecto
                  beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem
                  quia voluptas sit aspernatur aut odit aut fugit.
                </p>
                <b-button pill variant="primary">Learn more</b-button>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>

    <section class="dark-bg">
      <b-container class="py-5 mb-5">
        <b-row align-h="center">
          <b-col md="6">
            <div class="mb-5">
              <div class="block block--dark text-center">
                <h6>What we can do</h6>
                <h2>Our best services</h2>
                <p>
                  Morbi porttitor lobortis libero sit amet finibus. Aliquam
                  condimentum magna id metus pharetra, sed feugiat ipsum
                  interdum. Nam eget libero ut est varius ornare id sed nisl.
                </p>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col
            md="4"
            v-for="service in services"
            :key="service.id"
            class="grid-list text-center"
          >
            <div
              class="grid-list__item mb-5 mb-md-3"
              :class="{ 'mb-md-5': service.id < 3 }"
            >
              <font-awesome-icon
                :icon="['fas', service.icon]"
                size="3x"
                class="mb-3"
              ></font-awesome-icon>
              <h5>{{ service.name }}</h5>
              <p>{{ service.short_caption }}</p>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>

    <section>
      <b-container class="py-5 mb-5">
        <b-row>
          <b-col md="6" class="d-flex flex-column justify-content-center">
            <div class="block">
              <h6>What makes us special</h6>
              <h2>We focus on what matters to you</h2>
              <p>
                Sed ut perspiciatis unde omnis iste natus error sit voluptatem
                accusantium doloremque laudantium, totam rem aperiam.
              </p>
              <div>
                <div class="block__keypoint d-flex flex-row justify-content-between">
                  <div class="keypoint-icon">
                    <span class="fa-stack fa-2x mr-4">
                      <font-awesome-icon
                        :icon="['fas', 'circle']"
                        class="fa-stack-2x"
                      ></font-awesome-icon>
                      <font-awesome-icon
                        :icon="['fas', 'coins']"
                        class="fa-stack-1x"
                      ></font-awesome-icon>
                    </span>
                  </div>
                  <div class="keypoint-blurb">
                    <h5>Save money</h5>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipiscing
                      elit.Praesent sit amet rutrum justo doloremque
                      laudantium,totam rem aperiam.
                    </p>
                  </div>
                </div>
                <div class="block__keypoint d-flex flex-row justify-content-between">
                  <div class="keypoint-icon">
                    <span class="fa-stack fa-2x mr-4">
                      <font-awesome-icon
                        :icon="['fas', 'circle']"
                        class="fa-stack-2x"
                      ></font-awesome-icon>
                      <font-awesome-icon
                        :icon="['fas', 'code-branch']"
                        class="fa-stack-1x"
                      ></font-awesome-icon>
                    </span>
                  </div>
                  <div class="keypoint-blurb">
                    <h5>Revolutionary technology</h5>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipiscing
                      elit.Praesent sit amet rutrum justo doloremque
                      laudantium,totam rem aperiam.
                    </p>
                  </div>
                </div>
                <b-button href="#" pill variant="primary">Learn more</b-button>
              </div>
            </div>
          </b-col>
          <b-col md="6">
            <b-img
                fluid
                src="@/assets/finances-isometric.png"
                width="500"
                center>
            </b-img>
          </b-col>
        </b-row>
      </b-container>
    </section>

    <section>
      <b-container class="py-5 mb-5">
        <b-row align-h="center">
          <b-col md="6">
            <div class="block mb-5">
              <div class="section-title text-center">
                <h6>Testimonials</h6>
                <h2>What do our clients say</h2>
                <p>
                  Morbi porttitor lobortis libero sit amet finibus. Aliquam
                  condimentum magna id metus pharetra, sed feugiat ipsum
                  interdum. Nam eget libero ut est varius ornare id sed nisl.
                </p>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col
            v-for="testimonial in testimonials"
            :key="testimonial.id"
            sm="4"
            class="my-3"
          >
            <testimonial :testimonial="testimonial"></testimonial>
          </b-col>
        </b-row>
      </b-container>
    </section>
  </div>
</template>

<script>
import Testimonial from "../components/partials/Testimonial.vue";
import SingleService from "@/views/SingleService";
export default {
  name: "Home",
  data() {
    return {
      services: [
        {
          id: 1,
          name: "Web Development",
          icon: "code",
          short_caption:
            "Web Design & Development Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent sit amet rutrum justo."
        },
        {
          id: 2,
          name: "UX / UI Design",
          icon: "rocket",
          short_caption:
            "User Experience and User Interface design ipsum dolor sit amet, consectetur adipiscing elit. Praesent sit amet rutrum justo."
        },
        {
          id: 3,
          name: "Email Marketing",
          icon: "envelope",
          short_caption:
            "SEO Optimization Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent sit amet rutrum justo."
        },
        {
          id: 4,
          name: "SEO Optimization",
          icon: "search",
          short_caption:
              "SEO services meant to ipsum dolor sit amet, consectetur adipiscing elit. Praesent sit amet rutrum justo."
        },
        {
          id: 5,
          name: "Ads Management",
          icon: "ad",
          short_caption:
            "Ads Management Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent sit amet rutrum justo."
        },
        {
          id: 6,
          name: "Graphic Design",
          icon: "layer-group",
          short_caption:
            "Graphic Design Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent sit amet rutrum justo."
        }
      ],
      testimonials: [
        {
          first_name: "Jan",
          last_name: "Wallner",
          position: "Product Owner",
          industry: "Airline",
          testimonial:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent sit amet rutrum justo.",
        },
        {
          first_name: "Mike",
          last_name: "Alpha",
          position: "Project Manager",
          industry: "Banking",
          testimonial:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent sit amet rutrum justo.",
        },
        {
          first_name: "Tango",
          last_name: "Zulu",
          position: "Coordinator Special Projects",
          industry: "Event",
          testimonial:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent sit amet rutrum justo.",
        }
      ]
    };
  },
  components: {
    SingleService,
    Testimonial
  }
};
</script>

<style scoped lang="scss">

.banner {
  .jumbotron {
    min-height: 750px;
    background: $dark-blue url("~@/assets/digital-marketing-isometric.png") no-repeat 75% 50%;
    background-size: 500px;
    h1 {
      color: $white;
    }
    span {
      color: $light-blue;
    }
  }
  .btn-primary {
    border: 1px solid $light-blue;
  }
}

.ribbon {
  img {
    filter: grayscale(100%) contrast(0);
  }
}

@media only screen and (max-width: 576px) {
  .banner {
    .jumbotron {
      min-height: 500px;
      background: $dark-blue;

      h1 {
        width: 100% !important;
      }
    }
  }
}
</style>
